/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var TagTypeEnum;

(function (TagTypeEnum) {
  TagTypeEnum["API_FAILS"] = "api_fails";
  TagTypeEnum["REACHED_PAYMENT"] = "reached_payment";
  TagTypeEnum["MISSING_VIN"] = "missing_vin";
  TagTypeEnum["VIN_COLLECTED"] = "vin_collected";
  TagTypeEnum["DOC_SENT"] = "doc_sent";
  TagTypeEnum["REFERRAL_APPROVED"] = "referral_approved";
  TagTypeEnum["RENEWAL_PAYMENT_FAILED"] = "renewal_payment_failed";
  TagTypeEnum["MISSING_LOSS_REPORT"] = "missing_loss_report";
  TagTypeEnum["LOSS_REPORT_COLLECTED"] = "loss_report_collected";
  TagTypeEnum["FIXED_ERROR_SUBSCRIPTION_SCHEDULE"] = "fixed_error_subscription_schedule";
  TagTypeEnum["PROVIDER_CHANGE"] = "provider_change";
  TagTypeEnum["PARTIALLY_QUOTED"] = "partially_quoted";
  TagTypeEnum["PREMIUM_UPDATED_BY_JOVE"] = "premium_updated_by_jove";
  TagTypeEnum["DISPUTE"] = "dispute";
  TagTypeEnum["DISPUTE_STATUS"] = "dispute_status";
  TagTypeEnum["DISPUTE_SUBSCRIPTION_CANCELLED"] = "dispute_subscription_cancelled";
  TagTypeEnum["DISPUTE_GA_NOTIFIED"] = "dispute_ga_notified";
  TagTypeEnum["NEED_NO_CLAIM_REPORT_SIGN"] = "need_no_claim_report_sign";
  TagTypeEnum["NO_CLAIM_REPORT_SIGNED"] = "no_claim_report_signed";
  TagTypeEnum["NEED_CHARGE_RENEWAL_PREMIUM"] = "need_charge_renewal_premium";
})(TagTypeEnum || (TagTypeEnum = {}));